import React from 'react';
import CrossWhite from "../../../assets/images/cross_white.svg";
import CrossBlack from "../../../assets/images/cross_black.svg";
import Loading from '../../Views/Ui/Loading';
import AudioBarUi from '../../Views/Ui/AudioBarUi';
import GrammerModal from '../Logic/Grammer';
import DeleteBookmarlConfirmationModal from './DeleteBookmarkConfirmation';
import DeleteConfirmationModal from '../Logic/DeleteConfirmationNotes';
import NotesModal from '../Logic/Notes';
import { getTranslationDirection } from '../../../assets/js/translationDirection';
import { verseArabicForDisplay, verseWordByWordTranslationForScript, getVerseArabicText, verseArabicWordClassName, VERSE_END_MARKER_FONT_FAMILY } from '../../../assets/js/verseScriptText';

export default function ReadVerseModalUi(props) {
    if (!props.isOpen) {
        return null;
    }

    return (
        <div
            className="modal show"
            tabIndex="-1"
            onClick={(e) => e.target.classList.contains('modal') && props.onClose()}
            id="readVerseModal"
            role="dialog"
            aria-labelledby="readVerseModalLabel"
            style={{
                zIndex: 1050,
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: '100%',
                height: '100%',
                display: 'block'
            }}
        >
            <div
                className="dark__overlay"
                onClick={(e) => e.target.classList.contains('dark__overlay') && props.onClose()}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    height: '100%'
                }}
            />
            <div
                className="modal-dialog"
                style={{
                    position: 'fixed',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    margin: 0,
                    maxWidth: '700px',
                    width: 'min(90vw, 700px)',
                    minWidth: '300px',
                    height: '100vh',
                    transform: 'translateX(0)',
                    transition: 'transform 0.3s ease-in-out',
                    display: 'flex',
                    alignItems: 'stretch',
                    zIndex: 1051
                }}
            >
                <div
                    className="modal-content darkBackground dark-mode-modal-border d-flex flex-column"
                    style={{
                        height: '100%',
                        borderTopLeftRadius: '8px',
                        borderBottomLeftRadius: '8px',
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                        position: 'relative'
                    }}
                >
                    {/* Close button - fixed at top left */}
                    <img
                        alt='Close'
                        onClick={() => props.onClose()}
                        src={props.userTheme === 'Dark' ? CrossWhite : CrossBlack}
                        style={{
                            cursor: 'pointer',
                            position: 'absolute',
                            top: '1rem',
                            left: '1rem',
                            right: 'auto',
                            zIndex: 1060,
                            width: '12px',
                            height: '12px',
                            display: 'block'
                        }}
                    />

                    {/* Main content area with scroll */}
                    <div
                        className="flex-grow-1"
                        style={{
                            overflowY: 'auto',
                            flex: '1 1 auto',
                            minHeight: 0
                        }}
                        onScroll={props.handleScroll}
                    >
                        {props.loading && <Loading />}
                        <div className="m-auto all_verses" id="chapterContent" style={{ paddingBottom: 0 }}>
                            <div ref={props.topOfPageRef} id='TopOfThePage'></div>
                            <div className='page-wrap' style={{ marginBottom: 0, paddingBottom: 0 }}>
                                {/* Header with Surah name image - scrollable */}
                                <div className="d-flex w-100 justify-content-center">
                                    {(() => {
                                        // Get chapter number from currently displayed verses (dynamic)
                                        // Priority: allVerses (what's actually displayed) > currentChapter > singleVerse
                                        let chapterNo = null;
                                        if (props.allVerses && props.allVerses.length > 0) {
                                            chapterNo = props.allVerses[0].chapterNo;
                                        } else if (props.currentChapter) {
                                            chapterNo = props.currentChapter;
                                        } else if (props.singleVerse) {
                                            chapterNo = props.singleVerse.chapterNo;
                                        }
                                        if (chapterNo) {
                                            try {
                                                return (
                                                    <img
                                                        key={`surah-${chapterNo}`}
                                                        data-bs-theme="dark"
                                                        alt={"surah name"}
                                                        className={"vw-12"}
                                                        height="150px"
                                                        width="150px"
                                                        backgroundcolor={props.userTheme === 'Dark' ? '#FF66B1' : '#E92D71'}
                                                        style={{ filter: 'var(--special-filter)' }}
                                                        src={require(`../../../assets/images/chapters/${chapterNo}.svg`)}
                                                    />
                                                );
                                            } catch (e) {
                                                // Fallback if image doesn't exist
                                                return null;
                                            }
                                        }
                                        return null;
                                    })()}
                                </div>
                                {(() => {
                                    let chapterNo = null;
                                    if (props.allVerses && props.allVerses.length > 0) {
                                        chapterNo = props.allVerses[0].chapterNo;
                                    } else if (props.currentChapter) {
                                        chapterNo = props.currentChapter;
                                    } else if (props.singleVerse) {
                                        chapterNo = props.singleVerse.chapterNo;
                                    }
                                    if (chapterNo && props.chapters?.chapters?.length > 0) {
                                        return (
                                            <div className="text-center mb-3">
                                                <span className="font-size-18-600 text-white-black-theme">
                                                    {props.t('juz-part')}: {props.chapters.chapters[chapterNo - 1]?.partNo}
                                                </span>
                                            </div>
                                        );
                                    }
                                    return null;
                                })()}
                                {/* First Verse (Bismillah) - Only show if has translations */}
                                {props.FirstVerse && props.currentVerse === 1 && props.currentChapter !== 1 && props.FirstVerse.translations && props.FirstVerse.translations.length > 0 &&
                                    (() => {
                                        const isSelectedBismillah = props.singleVerse &&
                                            props.singleVerse.chapterNo === 1 &&
                                            props.singleVerse.verseNo === 1 &&
                                            props.currentChapter !== 1;
                                        return (
                                            <div
                                                ref={(props.playingVerse === 0 || props.playingVerse === 1111) ? props.playingVerseRef : null}
                                                className={`w-100 d-flex justify-content-center verses-body ${(props.playingVerse === 0 || props.playingVerse === 1111) ? 'playing-verse' : ''} ${isSelectedBismillah ? 'selected-verse' : ''}`}
                                            >
                                                <div id="verse-cell-blessing" className={`row w-100 pl-3 py-3 d-flex flex-row cell-border-bottom-blessing ${isSelectedBismillah ? 'selected-verse-content' : ''}`} style={{ direction: 'rtl' }}>
                                                    {props.FirstVerse && getVerseArabicText(props.scriptStyle, props.FirstVerse) && verseArabicForDisplay(props.scriptStyle, props.FirstVerse).split(' ').map((singleWord, index1) => {
                                                        props.wordRefs.current[index1] = React.createRef();
                                                        return (
                                                            <div
                                                                key={'word__' + index1}
                                                                ref={props.wordRefs.current[index1]}
                                                                style={{ fontSize: props.arabicFontSize + 'rem' }}
                                                                className={`text-right w-auto align-self-center m-1 p-0 ${props.scriptStyle} ${verseArabicWordClassName(props.scriptStyle)}`}
                                                            >
                                                                {singleWord}
                                                            </div>
                                                        );
                                                    })}

                                                    {props.showTranslation && props.FirstVerse.translations && props.FirstVerse.translations.length > 0 && (() => {
                                                        const sortedTranslations = [...props.FirstVerse.translations].sort((a, b) => {
                                                            const dirA = getTranslationDirection(a.translationText);
                                                            const dirB = getTranslationDirection(b.translationText);
                                                            if (dirA === dirB) return 0;
                                                            if (dirA === 'rtl') return -1;
                                                            return 1;
                                                        });

                                                        return sortedTranslations.map((translation, translation_id) => {
                                                            const direction = getTranslationDirection(translation.translationText);
                                                            const parser = new DOMParser();
                                                            const doc = parser.parseFromString(translation.translationText, 'text/html');
                                                            const textTranslationContent = doc.body.textContent || "";
                                                            return (
                                                                <div key={"translation__" + translation_id} className="w-100 d-flex flex-column">
                                                                    <span className="m-0 w-100 translation_name py-2 translation-text-alignment" data-direction={direction} style={{ fontSize: props.translationFontSize + "rem" }}>
                                                                        {translation.translator && translation.translator.translatorName}
                                                                    </span>
                                                                    <label
                                                                        className="m-0 w-100 py-2 translation-text-alignment"
                                                                        data-direction={direction}
                                                                        style={{ fontSize: props.translationFontSize + "rem" }}
                                                                    >
                                                                        {textTranslationContent}
                                                                    </label>
                                                                </div>
                                                            );
                                                        });
                                                    })()}
                                                </div>
                                            </div>
                                        );
                                    })()
                                }

                                {/* All Verses - Only show verses with translations */}
                                {props.allVerses.length > 0 && props.allVerses
                                    .filter(singleVerse => singleVerse.translations && singleVerse.translations.length > 0)
                                    .map((singleVerse, index, filteredArray) => {
                                        const isLastIndex = index === filteredArray.length - 1;
                                        const isSelectedVerse = props.singleVerse &&
                                            props.singleVerse.chapterNo === singleVerse.chapterNo &&
                                            props.singleVerse.verseNo === singleVerse.verseNo;
                                        return (
                                            <div
                                                key={singleVerse.verseNo + 'v'}
                                                id={singleVerse.verseNo}
                                                ref={
                                                    props.playingSurah === singleVerse.chapterNo && props.playingVerse === singleVerse.verseNo
                                                        ? props.playingVerseRef
                                                        : isSelectedVerse
                                                            ? props.selectedVerseRef
                                                            : null
                                                }
                                                className={`w-100 d-flex justify-content-center  verses-body  ${props.playingVerse === singleVerse.verseNo ? 'playing-verse' : ''} ${isSelectedVerse ? 'selected-verse' : ''}`}
                                            >
                                                {/* Verse content */}
                                                <div id="verse-cell" className={`w-100 pl-3 d-flex  flex-column  ${isLastIndex ? 'pt-3 pb-0' : 'py-3 cell-border-bottom'} ${isSelectedVerse ? 'selected-verse-content' : ''}`}>
                                                    {props.scriptStyle && props.arabicFontSize && getVerseArabicText(props.scriptStyle, singleVerse) &&
                                                        <div className="d-flex flex-row-reverse justify-content-start py-2 flex-wrap">
                                                            <div>
                                                            </div>
                                                            {verseArabicForDisplay(props.scriptStyle, singleVerse).split(" ").map(word => word.trim()).filter(word => word !== "").map((singleWord, index1) => {
                                                                props.wordRefs.current[index1] = React.createRef();
                                                                const wbwTranslation = verseWordByWordTranslationForScript(props.scriptStyle, singleVerse);
                                                                const fullArabic = verseArabicForDisplay(props.scriptStyle, singleVerse);
                                                                return (
                                                                    <div
                                                                        key={"word__" + index1}
                                                                        ref={props.wordRefs.current[index1]}
                                                                        onMouseEnter={() => props.togglePopupOverVerse(index1, index, singleWord)}
                                                                        onMouseLeave={() => props.handleMouseLeave()}
                                                                        style={{ fontSize: props.arabicFontSize + "rem" }}
                                                                        className={` elementHover  ${props.showVerseHoverPopup ? 'hovered' : ''} text-right w-auto align-self-center pl-2 ${props.scriptStyle} ${verseArabicWordClassName(props.scriptStyle)}`}
                                                                        aria-describedby="popup-2908"
                                                                    >
                                                                        {singleWord}
                                                                        {props.activeVerseWordIndex === index1 && props.activeVerseIndex === index && (
                                                                            <span className="tooltipVerseHoverText">
                                                                                {wbwTranslation != null && wbwTranslation !== undefined
                                                                                    ? props.WordPoup(singleWord, wbwTranslation, index1, fullArabic)
                                                                                    : ''}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                            <label
                                                                className="text-right  w-auto  align-self-center simple-font-family"
                                                                style={{ fontSize: props.arabicFontSize + "rem", fontFamily: VERSE_END_MARKER_FONT_FAMILY }}
                                                            >
                                                                {" \uFD3E" +
                                                                    singleVerse.verseNo.toLocaleString("ar-EG") +
                                                                    "\uFD3F"}
                                                            </label>
                                                        </div>
                                                    }

                                                    {/* Translations */}
                                                    {props.showTranslation && singleVerse.translations && singleVerse.translations.length > 0 && (() => {
                                                        const sortedTranslations = [...singleVerse.translations].sort((a, b) => {
                                                            const dirA = getTranslationDirection(a.translationText);
                                                            const dirB = getTranslationDirection(b.translationText);
                                                            if (dirA === dirB) return 0;
                                                            if (dirA === 'rtl') return -1;
                                                            return 1;
                                                        });

                                                        return sortedTranslations.map((translation, translation_id) => {
                                                            const direction = getTranslationDirection(translation.translationText);
                                                            const parser = new DOMParser();
                                                            const doc = parser.parseFromString(translation.translationText, 'text/html');
                                                            const textTranslationContent = doc.body.textContent || "";
                                                            return (
                                                                <div key={"translation__" + translation_id} className="w-100 d-flex flex-column">
                                                                    <span className="m-0 w-100 translation_name py-2 translation-text-alignment" data-direction={direction} style={{ fontSize: props.translationFontSize + "rem" }}>
                                                                        {translation.translator && translation.translator.translatorName}
                                                                    </span>
                                                                    <label
                                                                        className="m-0 w-100 py-2 translation-text-alignment"
                                                                        data-direction={direction}
                                                                        style={{ fontSize: props.translationFontSize + "rem" }}
                                                                    >
                                                                        {textTranslationContent}
                                                                    </label>
                                                                </div>
                                                            );
                                                        });
                                                    })()}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>

                    {/* Local AudioBar - completely independent */}
                    {props.localRecitations && props.localRecitations.length > 0 && (
                        <AudioBarUi
                            translationLoading={props.loading}
                            t={props.t}
                            reciterNames={props.localReciterNames || []}
                            selectedReciterId={props.localSelectedReciterId}
                            selectedReciterName={props.localSelectedReciterName}
                            shuffle={props.localShuffle}
                            playState={props.localPlayState}
                            recitations={props.localRecitations}
                            playingVerse={props.localPlayingVerse}
                            audioSrc={props.localAudioSrc}
                            open={props.localOpen}
                            setOpen={props.setLocalOpen}
                            openShuffle={props.localOpenShuffle}
                            setOpenShuffle={props.setLocalOpenShuffle}
                            audioRef={props.audioRef}
                            pauseThis={props.localPauseThis}
                            handleReciterChange={props.localHandleReciterChange}
                            handleShuffleChange={props.localHandleShuffleChange}
                            playVerse={props.localPlayVerse}
                            playNextVerse={props.localPlayNextVerse}
                            playPreviousVerse={props.localPlayPreviousVerse}
                            closeModal={props.localCloseModal}
                            closeModalShuffle={props.localCloseModalShuffle}
                            playBlackWhite={props.playBlackWhite}
                            pauseBlackWhite={props.pauseBlackWhite}
                            shuffle_Icon={props.shuffle_Icon}
                            arrowDownBlue={props.arrowDownBlue}
                            moveNext={props.moveNext}
                            movePrevious={props.movePrevious}
                            selectedSurah={props.localSelectedSurah}
                            selectedVerse={props.localPlayingVerse}
                            Pause={props.localPause}
                            playingSurah={props.localPlayingSurah}
                            firstVerse={props.localFirstVerse}
                            setAudioSrcToTHis={props.localSetAudioSrcToThis}
                            rangeOfVerses={props.localRangeOfVerses}
                            setRangeOfVerses={props.setLocalRangeOfVerses}
                            handleChapterChange={() => { }}
                            handleChapterToChange={() => { }}
                            handleFromVerseChange={() => { }}
                            ChapterOptions={props.ChapterOptions || []}
                            selectedOptionChapter={props.ChapterOptions?.find(opt => opt.value === props.localSelectedSurah) || null}
                            selectedOptionToChapter={null}
                            selectedOptionFromChapter={null}
                            onMenuOpen={() => { }}
                            dispatch={() => { }}
                            SettingActions={{}}
                            navigate={props.navigate}
                            userTheme={props.userTheme}
                            chapters={props.chapters}
                        />
                    )}

                    {/* Modals */}
                    {props.isGrammerModalOpen && props.chapters && (
                        <GrammerModal
                            t={props.t}
                            chapters={props.chapters}
                            Grammers={props.grammerModalVerse}
                            grammerModalVerseId={props.grammerModalVerseId}
                            updateGrammerVerseId={props.updateGrammerVerseId}
                            onClose={props.closeGrammerModal}
                            scriptStyle={props.scriptStyle}
                        />
                    )}
                    {props.isBookmarkConfirmationsModalOpen && (
                        <DeleteBookmarlConfirmationModal
                            t={props.t}
                            RemoveBookmark={props.RemoveBookmark}
                            DeleteBookmarkId={props.deleteNotesId}
                            onClose={props.closeBookmarkDeleteConfirmationModal}
                        />
                    )}
                    {props.isDeleteConfirmationsModalOpen && (
                        <DeleteConfirmationModal
                            t={props.t}
                            allVerses={props.allVerses}
                            NotesData={props.notesData}
                            DeleteNotesId={props.notesData.id}
                            setIsDeleteConfirmationsModalOpen={props.setIsDeleteConfirmationsModalOpen}
                            onClose={props.closeDeleteConfirmationModal}
                            setLoading={props.setLoading}
                        />
                    )}
                    {props.isNotesModalOpen && props.chapters && (
                        <NotesModal
                            t={props.t}
                            allVerses={props.allVerses}
                            NotesData={props.notesData}
                            setDeleteNotesId={props.setDeleteNotesId}
                            setLoading={props.setLoading}
                            chapters={props.chapters}
                            setIsDeleteConfirmationsModalOpen={props.setIsDeleteConfirmationsModalOpen}
                            setIsNotesModalOpen={props.setIsNotesModalOpen}
                            closeNotesModal={props.closeNotesModal}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
